/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'

const $nsid = 'app.bsky.actor.profile'

export { $nsid }

/** A declaration of a Bluesky account profile. */
type Main = {
  $type: 'app.bsky.actor.profile'
  displayName?: string

  /**
   * Free-form profile description text.
   */
  description?: string

  /**
   * Free-form pronouns text.
   */
  pronouns?: string
  website?: l.UriString

  /**
   * Small image to be displayed next to posts from account. AKA, 'profile picture'
   */
  avatar?: l.BlobRef

  /**
   * Larger horizontal image to display behind profile view.
   */
  banner?: l.BlobRef

  /**
   * Self-label values, specific to the Bluesky application, on the overall account.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  joinedViaStarterPack?: RepoStrongRef.Main
  pinnedPost?: RepoStrongRef.Main
  createdAt?: l.DatetimeString
}

export type { Main }

/** A declaration of a Bluesky account profile. */
const main = l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  l.object({
    displayName: l.optional(l.string({ maxGraphemes: 64, maxLength: 640 })),
    description: l.optional(l.string({ maxGraphemes: 256, maxLength: 2560 })),
    pronouns: l.optional(l.string({ maxGraphemes: 20, maxLength: 200 })),
    website: l.optional(l.string({ format: 'uri' })),
    avatar: l.optional(
      l.blob({ accept: ['image/png', 'image/jpeg'], maxSize: 1000000 }),
    ),
    banner: l.optional(
      l.blob({ accept: ['image/png', 'image/jpeg'], maxSize: 1000000 }),
    ),
    labels: l.optional(
      l.typedUnion(
        [l.typedRef<LabelDefs.SelfLabels>((() => LabelDefs.selfLabels) as any)],
        false,
      ),
    ),
    joinedViaStarterPack: l.optional(
      l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
    ),
    pinnedPost: l.optional(
      l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
    ),
    createdAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
